import { WatchListEntryEsModel } from "./RabbitSolutions";

export interface ComplianceSearchRequest {
    clientId?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    searchLists?: SearchListEnum[] | null;
    minimumMatchingPercentagePEP?: number | null;
    minimumMatchingPercentageNIL?: number | null;
    percentageMatch?: number | null;
    matchThreshold?: number | null;
    additionalData?: { [key: string]: any } | null;
}

export interface ComplianceSearchResponse {
    clientId?: string | null;
    isMatch?: boolean | null;
    isMatchedInPEP?: boolean | null;
    isMatchedInRSA?: boolean | null;
    isMatchedInSIP?: boolean | null;
    isMatchedInSIE?: boolean | null;
    isMatchedInNIL?: boolean | null;
    isMatchedInRequestedSearchLists?: boolean | null;
    matchScore?: number | null;
    matchReason?: string | null;
    minimumMatchingPercentagePEP?: number | null;
    minimumMatchingPercentageNIL?: number | null;
    consumedTimeInMs?: number | null;
    searchTimestamp?: string | null;
    watchListEntries?: WatchListEntryEsModel[] | null;
    additionalData?: { [key: string]: any } | null;
}

export interface ComplianceBatchResponse {
    results: ComplianceSearchResponse[];
    totalProcessed: number;
    successfulSearches: number;
    failedSearches: number;
}

export interface ComplianceOnboardResponse {
    isSuccessful: boolean;
    onboardingId?: string | null;
    status?: string | null;
    errorMessage?: string | null;
    additionalData?: { [key: string]: any } | null;
}

export interface ComplianceHealthResponse {
    isHealthy: boolean;
    providerName?: string | null;
    message?: string | null;
    checkedAt: string;
}

export enum SearchListEnum {
    NotSpecified = "NotSpecified",
    PEP = "PEP",
    RCA = "RCA",
    SIP = "SIP",
    SIE = "SIE",
    NIL = "NIL",
}